import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import {
  loadRecommendationsForRestaurantsPlacesNear, loadRecommendationsForRestaurantsRestaurants
} from '@common/redux/slices/recommendation.slice';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { loadRestaurant } from "@common/redux/slices/restaurants.slice";
import { SingleRestaurant } from "@kursk/components/pages/SingleRestaurant/SingleRestaurant";
import { placePageProps } from "@kursk/utils/entitiesPages";
import { loadFeedbacks } from "@common/redux/slices/feedbacks.slice";

export default function page({ notFound }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return (
    <SingleRestaurant />
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params, req }) => {
  const { id } = params;
  await Promise.all([
    store.dispatch<any>(loadRestaurant({ _id: id })),
    store.dispatch<any>(loadRecommendationsForRestaurantsPlacesNear({ _id: id })),
    store.dispatch<any>(loadRecommendationsForRestaurantsRestaurants({ _id: id })),
    store.dispatch<any>(loadFeedbacks({ type: 'restaurant', restaurantId: Number(id) })),
  ]);
  const { restaurant } = store.getState().restaurantsList;
  return placePageProps(restaurant, req)
});
